"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../index");
const awscred = require("awscred");
const aws4 = require("aws4");
const SwaggerClient = require("swagger-client");
const URI = require("urijs");
class ApiClient {
    constructor(config, options) {
        this.config = config;
        this.options = options;
    }
    // -----------------------------------------------
    //    Public methods
    // -----------------------------------------------
    async request(service, method, payload) {
        const client = await this.getClientPromise();
        if (!client.apis[service]) {
            this.options.logger.error({}, `API service '${service}' not found.`);
            throw new Error(`API service '${service}' not found.`);
        }
        const implementation = client.apis[service][method];
        if (!implementation) {
            this.options.logger.error({}, `API method '${method}' of service '${service}' not found.`);
            throw new Error(`API method '${method}' of service '${service}' not found.`);
        }
        this.options.logger.debug({}, `Backend request ${service}/${method}`);
        try {
            const res = await implementation(payload);
            return res.obj;
        }
        catch (error) {
            if (error.obj) {
                throw new index_1.ApiError(Object.assign({ service, method }, error.obj));
            }
            if (error.status === 0 || error.statusCode === 0) {
                throw new index_1.ApiError({
                    service,
                    method,
                    status: 0,
                    message: 'Application is offline.'
                });
            }
            if (error.status > 0 || error.statusCode > 0) {
                throw new index_1.ApiError({
                    service,
                    method,
                    status: error.statusCode || error.status,
                    url: error.response && error.response.url,
                    message: (error.response && error.response.body && error.response.body.message)
                        || (error.response && error.response.statusText)
                });
            }
            if (error.errorObj) {
                throw new index_1.ApiError(Object.assign({ service, method }, error.errorObj));
            }
            throw error;
        }
    }
    // -----------------------------------------------
    //    Private methods
    // -----------------------------------------------
    async getClientPromise() {
        if (!this.client) {
            let url;
            let spec;
            if (!this.config.api) {
                throw new Error('Missing API configuration.');
            }
            if (this.config.api.spec) {
                spec = this.config.api.spec;
            }
            else if (this.config.api.host) {
                url = 'https://';
                url += this.config.api.host + this.config.api.path + '/swagger.json';
            }
            else {
                throw new Error('Invalid API configuration.');
            }
            this.client = new SwaggerClient({
                url,
                spec,
                usePromise: true,
                requestInterceptor: async (req) => {
                    const uri = URI(req.url);
                    const opts = {
                        method: req.method,
                        host: uri.host(),
                        path: uri.resource(),
                        json: true,
                        headers: Object.assign({}, req.headers),
                        region: this.config.region,
                        service: 'execute-api',
                        body: req.body,
                    };
                    const credentials = await new Promise((resolve, reject) => {
                        awscred.loadCredentials((error, data) => {
                            if (error) {
                                return reject(error);
                            }
                            resolve(data);
                        });
                    });
                    // const credentials = AWS.config.credentials;
                    const signer = new aws4.RequestSigner(opts, credentials);
                    signer.sign();
                    req.headers = opts.headers;
                    return req;
                }
            });
        }
        try {
            const client = await this.client.then(c => c);
            return client;
        }
        catch (error) {
            this.client = null;
            this.options.logger.error({ error }, 'Unable to get the API specification.');
            throw error;
        }
    }
}
exports.ApiClient = ApiClient;
